<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select v-model="form.dataSource" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in columnData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          @change="sourceChange"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="排列方式">
      <el-select v-model="form.layout" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in bannnerType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item label="图片展示">
      <el-select v-model="form.imageFit" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in imageFitType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="展示条数">
      <el-input-number
        v-model="form.pageSize"
        :min="1"
        :max="100"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <!-- <el-form-item label="显示名称" v-if="form.showTitle">
      <el-input
        v-model="form.title"
        placeholder="显示名称"
        @input="selectChange"
        maxlength="20"
        clearable
      />
    </el-form-item> -->
    <!-- <el-form-item label="显示边框圆角">
      <el-checkbox v-model="form.isBorderRadius" @change="selectChange"></el-checkbox>
    </el-form-item> -->
    <!-- <el-form-item label="显示栏目名称">
      <el-checkbox v-model="form.showTitle" @change="selectChange"></el-checkbox>
    </el-form-item> -->
    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { bannnerType, imageFitType } from '../../js/config'
import layoutConfig from './LayoutConfig'

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      form: {
        dataSource: '', // 数据来源
        layout: 'BannerLong', // 展示方式
        pageSize: 1, // 展示条数
        imageFit: 'fill',
        title: '', // 显示名称
        showTitle: true, // 显示栏目名称
      },
      config: {
        component: bannnerType[0].value,
        w: 10,
        h: 10,
      },
      columnData: [],
      bannnerType,
      imageFitType,
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          _.assign(this.form, val)
        } else {
          this.form = this.$options.data().form
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'component', 'type', 'x', 'y', 'i'])
        }
      },
    },
  },
  methods: {
    sourceChange() {
      this.form.title = _.find(this.columnData, { id: this.form.dataSource }).name
      this.selectChange()
    },
    async getColumnData() {
      const [err, res] = await columnApi.tree(1)
      if (!err) {
        this.columnData = _.filter(res, (item) => {
          return item.type === this.config.type
        })
      }
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
  },
  created() {
    this.getColumnData()
  },
}
</script>

<style></style>
